const init = () => {
  const toggleEls = [...document.querySelectorAll('[data-menu-target]')];

  if (!toggleEls.length) {
    return { closeMenus: () => { } };
  }

  const subToggleEls = [...document.querySelectorAll('.MegaMenuNav a[href="#"]')];

  const { close: closeMainMenu } = useToggles({
    els: toggleEls,
    panelSelectorFromParent: '.MegaMenu',
  });
  const { close: closeSubMenu } = useToggles({
    els: subToggleEls,
    panelSelectorFromParent: '.sub-menu',
  });

  const closeMenus = () => {
    closeMainMenu();
    closeSubMenu();
  };

  // handle mobile back buttons to close wrapping mega menu
  const closeButtons = [...document.querySelectorAll('[data-target="mega-menu-close"]')];
  if (closeButtons.length) {
    closeButtons.forEach((button) => {
      const menu = button.closest('.menu-item');
      if (!menu) {
        return;
      }
      button.addEventListener('click', (event) => {
        event.preventDefault();
        menu.classList.remove('is-active');
      });
    });
  }

  // Add right-aligned class to sub-menus that would overflow the viewport
  const checkSubMenuPosition = () => {
    const menuItems = document.querySelectorAll('.MegaMenuNav .menu-item-has-children');
    menuItems.forEach(menuItem => {
      const subMenu = menuItem.querySelector('.sub-menu');
      if (!subMenu) return;

      // Temporarily show the sub-menu to measure it
      const wasHidden = subMenu.style.display === 'none';
      if (wasHidden) {
        subMenu.style.display = 'block';
      }

      const menuItemRect = menuItem.getBoundingClientRect();
      const subMenuRect = subMenu.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      // Check if sub-menu would overflow the right edge
      const wouldOverflowRight = menuItemRect.right + subMenuRect.width > viewportWidth;

      // Check if sub-menu would overflow the left edge if we position it to the left
      const wouldOverflowLeft = menuItemRect.left - subMenuRect.width < 0;

      // Position to the left if it would overflow the right edge and not overflow the left edge
      if (wouldOverflowRight && !wouldOverflowLeft) {
        subMenu.classList.add('right-aligned');
      } else {
        subMenu.classList.remove('right-aligned');
      }

      // Hide the sub-menu again if it was hidden
      if (wasHidden) {
        subMenu.style.display = 'none';
      }
    });
  };

  // Check positions on load and when window is resized
  checkSubMenuPosition();
  window.addEventListener('resize', checkSubMenuPosition);

  // Also check when a sub-menu is about to be shown
  subToggleEls.forEach(toggle => {
    toggle.addEventListener('click', () => {
      // Small delay to allow the menu to be shown before checking position
      setTimeout(checkSubMenuPosition, 0);
    });
  });

  return { closeMenus };
};

const useToggles = ({ els, panelSelectorFromParent, activeClass = 'is-active' }) => {
  let lastParent;
  els.forEach((el) => {
    const parent = el.parentNode;
    const panel = parent.querySelector(panelSelectorFromParent);

    const handleOutsideClick = (event) => {
      const isInsideClick = panel.contains(event.target);
      if (isInsideClick) {
        return;
      }
      parent.classList.remove(activeClass);
      document.removeEventListener('click', handleOutsideClick);
    };

    el.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      // If not active, show it
      if (!parent.classList.contains(activeClass)) {
        parent.classList.add(activeClass);
        document.addEventListener('click', handleOutsideClick);

        // Active, hide it
      } else {
        parent.classList.remove(activeClass);
        document.removeEventListener('click', handleOutsideClick);
      }

      // Close last parent if open
      if (lastParent && lastParent !== parent) {
        lastParent.classList.remove(activeClass);
      }
      lastParent = parent;
    });
  });

  return {
    close: () => {
      if (lastParent) {
        lastParent.classList.remove(activeClass);
      }
    },
  };
};


let myLis = document.querySelectorAll('#nvision-desktop-menu li.menu-item-has-children');
//console.log(myLis);

if (window.innerWidth < 1080) {
  for (let index = 0; index < myLis.length; index++) {
    const element = myLis[index];

    element.addEventListener('click', function () {

      if (element.children.length > 1) {
        let ul = element.children[1];
        if (ul.tagName == 'UL') {
          if (ul.style.display == 'block') {
            ul.style.display = 'none';
          } else {
            ul.style.display = 'block';
          }
        }
      }
    })

  }
}

// Add near the top of the file where other event listeners are initialized
document.addEventListener('DOMContentLoaded', function () {
  const locationFinderTriggers = document.querySelectorAll('.location-finder-trigger > a');
  locationFinderTriggers.forEach(trigger => {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      MicroModal.show('modal-location-finder', {
        openTrigger: 'data-modal-open',
        closeTrigger: 'data-modal-close',
        disableScroll: true,
        disableFocus: true,
        title: 'Find a Location Near You'
      });
    });
  });
});

export default init;
